
export function ebCtnValidate () {
  const ebCtnRules = [
    {
      property: 'ctnNo',
      ruleName: "notNull",
      message: "箱信息不能为空"
    },
    {
      property: 'vgmVerifyDate',
      ruleName: "notNull",
      message: "称重时间不能为空"
    },
    {
      property: 'vgmVerifyType',
      ruleName: "notNull",
      message: "称重方式不能为空"
    },

  ];
  return ebCtnRules;
}
